var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about-us"},[_c('CommonHeader',[_vm._v(_vm._s(_vm.$t('setting.about.name')))]),_c('main',[_c('div',{staticClass:"content markdown-body",domProps:{"innerHTML":_vm._s(_vm.body)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }